import React from 'react'
import Homee from '../Component/Home/Home'
const Home = () => {
  return (
    <>
    <Homee/>

    </>
  )
}

export default Home